module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai290-e3aa4bf6a0701b3af0f58d93be532347.jpg";